import type { SaveBarProps } from "./save-bar.type";

import { SaveBarButtons } from "./save-bar-buttons";
import { SaveBarIcon } from "./save-bar-icon";
import { SaveBarMessage } from "./save-bar-message";
import { getSaveBarStatus } from "./save-bar.helper";

import "./save-bar.style.less";

export const SaveBar = ({
  loading = false,
  sticky = false,
  hasChanges,
  date,
  onSave,
  onCancel,
}: SaveBarProps) => {
  const status = getSaveBarStatus(hasChanges);

  return (
    <>
      <div
        className={`save-bar-wrapper ${sticky ? "sticky" : ""}`}
        data-testid="save-bar"
      >
        <div className={`save-bar ${status}`}>
          <SaveBarIcon status={status} />
          <SaveBarMessage hasChanges={hasChanges} date={date} />
          <SaveBarButtons
            hasChanges={hasChanges}
            loading={loading}
            onCancel={onCancel}
            onSave={onSave}
          />
        </div>
      </div>
    </>
  );
};
